<template>
    <div class="event-preview">
        <div class="event-preview__bar">
            <div class="event-preview__back" @click="$router.back()">
                <GI name="global_previous" :ws="isPhone ? '30' : '32'" :hs="isPhone ? '14' : '16'"></GI>
                <span>{{ langJson('Back') }}</span>
            </div>
            <button class="event-preview__exit" @click="exit">{{ langJson('Exit preview') }}</button>
        </div>
        <EventDetailView v-if="event" :event="event"></EventDetailView>
        <div v-else-if="error" class="event-preview__error">{{ error }}</div>
    </div>
</template>
<script>
import organizerApi from '@/api/organizer'
import { apiErrorMessage } from '@/assets/js/organizerEvent'

// Organiser-only preview of the public event page — works for drafts, which the
// public /events/:id route doesn't serve.
export default {
    name: 'EventPreviewPage',
    data() {
        return { event: null, error: '' }
    },
    created() {
        this.$store.commit('saveHeadView', { create: false })
        this.load()
    },
    methods: {
        async load() {
            try {
                const res = await organizerApi.getEvent(this.$route.query.id)
                this.event = res.data
            } catch (err) {
                this.error = apiErrorMessage(err, this.langJson('Could not load this event'))
            }
        },
        exit() {
            this.$router.push({ path: '/brand/events/overview', query: { id: this.$route.query.id } })
        },
    },
}
</script>
<style lang="scss" scoped>
.event-preview {
    max-width: var(--max_width);
    margin: 0 auto;
    padding: 0 0 64px;

    &__bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 96px;
    }
    &__back {
        display: flex;
        align-items: center;
        gap: 16px;
        cursor: pointer;
        font-family: 'Inter';
        font-weight: 700;
        font-size: 18px;
        color: var(--font_deep_color);
    }
    &__exit {
        background: var(--color_white);
        border: 1.5px solid var(--danger_color);
        color: var(--danger_color);
        border-radius: 50px;
        padding: 10px 24px;
        font-family: 'Inter';
        font-weight: 700;
        font-size: 14px;
        cursor: pointer;
    }
    &__error {
        padding: 64px 0;
        text-align: center;
        font-family: 'Lato';
        color: var(--font_modif_color);
    }
}

@media only screen and (max-width: 1080px) {
    .event-preview {
        padding: 0 16px 48px;

        &__bar {
            min-height: 64px;
        }
    }
}
</style>
